import React from 'react';
import { useTranslation } from 'react-i18next';

import { Header } from './Header';

export const AuthLayout = (props: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <i className="ri-loader-line spin-icon" />
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        <Header />
        <div className="main-content">{props.children}</div>
      </div>
      <div
        className={
          'tw-fixed tw-bg-gray900 tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-z-40 tw-justify-center tw-items-center tw-hidden landscape:tw-flex'
        }
      >
        <p className={'tw-text-gray0 tw-text-[24px] tw-font-semibold'}>
          {t('image_picker.rotate_device')}
        </p>
      </div>
    </React.Fragment>
  );
};
